export const contentTypeJson = { "Content-Type": "application/json" };
